var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div kendo-grid=\"moduloCtrl.utentiGrid\" k-options=\"moduloCtrl.utenti\">\n<div k-detail-template>\n<div ng-include=\"'checkpermessi.html'\"></div>\n</div>\n</div>";
var id1="tabutenti.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;